<template>
  <div>
    <v-data-table v-model="payload.selection" :headers="headers"
      :must-sort="true"
      :loading="payload.loading"
      :item-key="payload.list.id"
      :items="payload.list"
      :footer-props="getFooterItems()"
      @item-expanded="(item) => payload.onExpand(item) || false"
      :show-select="payload.showSelect"
      :show-expand="payload.expand"
      :single-expand="true"
      :page.sync="payload.page"
      :expanded.sync="payload.expanded"
      :search="!total ? search : undefined"
      :server-items-length="total ? total : undefined"
      :options.sync="paginationMap" dense class="elevation-1 bordered--table"
      @dblclick:row="rowClicked"
      :hide-default-footer="payload.hideFooter ? payload.hideFooter : false">
      <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
        <v-simple-checkbox :ripple="false" color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
      </template>
      <template v-slot:top>
        <template v-if="!payload.selection.length">
          <template class="mt-1">
            <v-layout row class="mx-auto pa-2" :class="payload.isHideAdd ? 'mb-1' : ''" v-if="!payload.hasFilters">
              <v-flex sm8 xs4 class="mb-4">
                <template v-if="!payload.isHideAdd">
                  <v-menu v-if="payload.isAddnewAsMenu && payload.addMenuActions" offset-y :close-on-content-click="true">
                    <template #activator="{ on, attrs }">
                      <v-btn height="35" class="px-5" v-on="on" v-bind="attrs" color="primary" dark id="newbtn">{{ $t('new') }}</v-btn>
                    </template>
                    <div :style="payload.isChecklist ? {height:'340px',maxWidth:'190px'} : ''" :class="payload.isChecklist ? 'apply-scroll' : ''">
                      <v-list dense>
                        <v-list-item-group>
                          <template v-for="(item, index) in payload.addMenuActions">
                            <v-list-item v-if="item.isShow" :key="index" @click="item.click ? item.click() : '';payload.isChecklist ? $emit('setProperty', item) : ''">
                              <v-list-item-action class="custom-list-view" v-if="item.icon">
                                <v-icon size="20">{{item.icon}}</v-icon>
                              </v-list-item-action>
                              <v-list-item-title>
                                {{ $t(item.label) }}
                              </v-list-item-title>
                            </v-list-item>
                          </template>
                        </v-list-item-group>
                      </v-list>
                    </div>
                  </v-menu>
                  <v-btn small v-else color="primary" dark id="newbtn" @click="payload.addNewRoute">{{ $t('new') }}</v-btn>
                </template>
                <v-btn v-else-if="!payload.isHideAdd" color="primary" dark id="newbtn" @click="payload.addNewRoute">{{ $t('message.common.new') }}</v-btn>
                <v-btn v-else-if="payload.addClickHandler" :disabled="payload.isTechRole" color="primary" id="newbtn" @click="payload.addClickHandler">{{ $t('message.common.new') }}</v-btn>
              </v-flex>
              <v-flex sm4 xs8 v-if="!payload.isStock && !payload.hasFilters">
                <v-text-field hide-details dense outlined append-icon="search" single-line v-model="search" :label="$t('message.common.search')" class="text-xs-right" id="searchbtn"></v-text-field>
              </v-flex>
            </v-layout>
            <slot name="filterForm" v-if="payload.hasFilters"></slot>
          </template>
        </template>
        <v-toolbar v-else :elevation="!!payload.selection.length ? 5 : 0" :color="!!payload.selection.length ? 'primary' : 'white'">
          <v-slide-y-transition v-if="payload.selection.length">
            <v-btn icon @click="payload.selection = []">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-slide-y-transition>
          <v-slide-y-transition>
            <v-toolbar-title v-if="payload.selection.length">
              <div class="white--text">{{ `${payload.selection.length} selected` }}</div>
            </v-toolbar-title>
          </v-slide-y-transition>
          <v-spacer  v-if="payload.selection.length"></v-spacer>
          <template v-if="payload.selection.length">
            <v-slide-y-transition>
              <v-btn rounded @click="printIds" class="black--text mr-2" color="white" key="print" v-if="payload.isProductSelect">
                {{ $t('message.product.printLbl') }}
              </v-btn>
            </v-slide-y-transition>
            <v-slide-y-transition>
              <v-btn rounded @click="exportIds" class="black--text mr-2" color="white" key="export" v-if="payload.isProductSelect">
                {{ $t('message.common.export') }}
              </v-btn>
            </v-slide-y-transition>
            <v-slide-y-transition v-if="payload.isOffer">
              <v-btn rounded @click="invoiceEntries" class="black--text" color="white" key="invoice" v-if="showInvoice">
                {{ $t('message.customer.invoice') }}
              </v-btn>
            </v-slide-y-transition>
            <v-slide-y-transition v-else>
              <v-btn rounded @click="deleteEntries" :disabled="payload.isTechRole" class="black--text" color="white" key="delete">
                {{ $t('message.common.delete') }}
              </v-btn>
            </v-slide-y-transition>
          </template>
        </v-toolbar>
      </template>
      <template #[`item.${payload.editProp}`]="{ item }">
        <template>
          <router-link v-if="payload.editURL" :to="payload.editURL(item)">{{ item[payload.editProp] }}</router-link>
          <a v-else-if="payload.is_checklist" @click="payload.editHandler(item)" class="underline">{{ item[payload.editProp] }}</a>
          <a v-else @click="payload.editHandler(item.id)" class="underline">{{ item[payload.editProp] }}</a>
        </template>
      </template>
      <template #[`item.${payload.editProp1}`]="{ item }">
        <template>
          <a class="underline" v-if="payload.editURL1 && payload.editProp1 === 'oncustomerorder' && +($formatter.replaceCommaWithDot(item[payload.editProp1])) > 0" @click="payload.editURL1(item)">
            {{ (+($formatter.replaceCommaWithDot(item.oncustomerorder)) + +($formatter.replaceCommaWithDot(item.onproductionorder))) | replaceDotWithComma }}
          </a>
          <span v-else>{{ item[payload.editProp1] }}</span>
        </template>
      </template>
      <template #[`item.${payload.editProp2}`]="{ item }">
        <template>
          <router-link v-if="payload.editURL2 && payload.editProp2 === 'onorder' && +($formatter.replaceCommaWithDot(item[payload.editProp2])) > 0" :to="payload.editURL2(item)">{{ item[payload.editProp2] }}</router-link>
          <span v-else>{{ item[payload.editProp2] }}</span>
        </template>
      </template>
      <template #[`item.deviation_number`]="{ item }">
        <template>
          <router-link :to="`deviations/actions/${item.deviation_id}`">{{ item.deviation_number }}</router-link>
        </template>
      </template>
      <template #[`item.source_ref_number`]="{ item }" v-if="payload.isOffer">
        <template>
          <router-link :to="`orders/edit/${item.source_ref}/view`">{{ item.source_ref_number }}</router-link>
        </template>
      </template>
      <template #[`item.${payload.statusColor}`]="{ item }">
        <template>
          <v-chip small :color="item[payload.applyColor] ? item[payload.applyColor] : 'primary'" :text-color="$_foreGroundColor(item[payload.applyColor])">  {{item[payload.statusColor]}}</v-chip>
        </template>
      </template>
      <template #[`item.states`]="{ item }">
        {{ getStringifiedData(item.states) }}
      </template>
      <template #[`item.checklist`]="{ item }">
        <v-badge color="#335169" v-if="item.checklistcount" :content="item.checklistcount" overlap class="ml-1" icon v-show="item.id">
          <v-icon @click="payload.openchecklist(item)">
            mdi-text-box-plus
          </v-icon>
        </v-badge>
      </template>
      <!-- HAVE ONEDRIVE LINK ON CUSTOMER AND PRODUCT -->
      <template #[`item.${payload.onedriveProp}`]="{ item }">
        <template>
          <v-hover v-slot:default="{ hover }">
            <div>
              <router-link v-if="payload.editURL" :to="payload.editURL(item)">{{ item[payload.editProp] }}</router-link>
              <v-fade-transition>
                <v-icon v-if="hover && item.onedrive_link" small @click="navigateToOD(item.onedrive_link)">launch</v-icon>
              </v-fade-transition>
            </div>
          </v-hover>
        </template>
      </template>
      <template v-for="(field, index) in booleanItems" #[`item.${field}`]="{ item }">
        <v-icon class="font--style" :key="index"> {{ item[field] ? 'done' : 'clear' }} </v-icon>
      </template>
      <template v-slot:expanded-item="{ item, headers }">
        <td :colspan="headers.length">
          <template v-if="payload.expandHeader && payload.expandHeader.length > 0">
            <v-simple-table dense width="100%" class="dense_table bordered--table">
              <thead>
                <tr>
                  <th v-for="(headers, index) in payload.expandHeader" :key="index">{{headers.text}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, i) in item[payload.expandItem]" :key="i">
                  <td v-for="(headers, index) in payload.expandHeader" :key="index">{{product[`${headers.value}`] }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>
          <slot name="expand" v-else></slot>
        </td>
      </template>
      <template v-slot:[`item.color`]="{ item }">
        <v-chip small :color="item.color" v-if="item.color" :text-color="$_foreGroundColor(item.color)">{{ item.color }}</v-chip>
      </template>
      <template v-slot:[`item.status.text`]="{ item }" v-if="payload.isccsheet">
        {{ $t(item.status.text) }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn icon v-for="(action, index) in payload.actionsList" text
          v-show="action.is_show(item)"
          class="pa-0 action--btns ml-1"
          :style="{ color: action.color ? action.color(item) : '' }"
          @click="action.click(item)" :key="index">
          <v-icon>{{ action.icon(item) }}</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: ['payload', 'pagination', 'total', 'headers'],
  model: {
    prop: 'pagination',
    event: 'change'
  },
  data () {
    return {
      paginationList: {
        itemsPerPageOptions: [10, 25, 50, 100, -1]
      },
      paginationMap: this.pagination,
      search: '',
      booleanItems: [],
      showInvoice: false
    }
  },
  computed: {
    ...mapState(['workFlowStates'])
  },
  watch: {
    paginationMap (newValue) {
      if (!this.$formatter.isEmptyObject(newValue)) {
        const result = Object.assign({ ...this.paginationMap }, { search: this.search })
        this.$emit('change', result)
      }
    },
    search (val) {
      const search = Object.assign({ ...this.paginationMap }, { search: val })
      this.$emit('change', search)
    },
    'payload.selection' (val) {
      if (val) {
        if (this.payload.isOffer) {
          const selectedItems = this.payload.selection.map(x => x)
          if (selectedItems && selectedItems.length > 0) {
            const stateToInvoice = selectedItems.filter(x => x.status === 'to_invoice')
            if (stateToInvoice && stateToInvoice.length > 0) this.showInvoice = true
            else this.showInvoice = false
          }
        }
      }
    }
  },
  mounted () {
    this.getBoolItems()
  },
  methods: {
    rowClicked (event, { item }) {
      if (this.payload.rowClick) this.payload.rowClick(item)
    },
    getFooterItems () {
      if (this.payload.module === 'products') return { itemsPerPageOptions: [10, 25, 50, 100, 300] }
      else return { itemsPerPageOptions: [10, 25, 50, 100, 300, -1] }
    },
    getBoolItems () {
      const booleanList = this.headers ? this.headers.filter(x => x.isBoolean) : []
      this.booleanItems = booleanList.map(x => x.value)
    },
    deleteEntries () {
      const ids = this.payload.selection.map(x => x.id)
      const data = { module: this.payload.module, ids }
      this.$eventBus.$emit('deleteItems', data)
    },
    exportIds () {
      const ids = this.payload.selection.map(x => x.id)
      this.payload.export(ids)
    },
    invoiceEntries () {
      const ids = this.payload.selection.map(x => x.id)
      this.payload.changeState(ids)
    },
    printIds () {
      const list = this.payload.selection.map(x => x)
      this.payload.print(list)
    },
    navigateToOD (url) {
      window.open(url, '_blank')
    },
    getStringifiedData (data) {
      if (data) {
        var list = JSON.parse(data)
        if (list.length > 0) {
          var translatedList = []
          for (var i = 0; i < list.length; i++) {
            var workflowList = this.$formatter.cloneVariable(this.workFlowStates)
            var getState = workflowList.find(x => x.id === list[i])
            if (getState) translatedList.push(getState.name)
          }
          return translatedList.toString()
        } else return ''
      } else return ''
    },
    customSort (items, index, isDesc) { // items not returning
      const listOfColumns = this.payload.customSortColumns || []
      return this.$_customSorting(items, index[0], isDesc[0], listOfColumns)
    }
  }
}
</script>
<style>
.action--btns.v-btn--icon.v-size--default {
  height: 25px !important;
  width: 25px !important;
}
.underline {
  text-decoration: underline;
}
</style>
